import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const RightSidebarWrapper = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  width: ${props => `${props.width}px`};
  // height: 100%;
  background: ${props => props.backgroundColor};
  position: absolute;
  z-index: 1;
  overflow-y: scroll;
`;

const RightSidebar = ({
  open,
  width,
  children,
  backgroundColor,
  customStyle,
}) => {
  if (!open) {
    return null;
  }
  return (
    <RightSidebarWrapper
      width={width}
      backgroundColor={backgroundColor}
      style={customStyle}
    >
      {children}
    </RightSidebarWrapper>
  );
};

RightSidebar.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  open: PropTypes.bool.isRequired,
  backgroundColor: PropTypes.string,
  customStyle: PropTypes.object,
};

RightSidebar.defaultProps = {
  width: 400,
  backgroundColor: '#00253a',
  customStyle: {},
};

export default RightSidebar;



// WEBPACK FOOTER //
// ./src/components/RightSidebar/RightSidebar.js